/* unplugin-vue-components disabled */import script from "./RouteManager.vue?vue&type=script&setup=true&lang=js"
export * from "./RouteManager.vue?vue&type=script&setup=true&lang=js"

import "./RouteManager.vue?vue&type=style&index=0&id=119750f4&lang=scss"

const __exports__ = script;

export default __exports__